<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 23 11">
    <g clip-path="url(#clip0_7100_81)">
      <path
        d="M3.178 10.9557C3.33998 11.0297 3.51669 11.0149 3.66395 10.9113L9.09768 6.92878C9.24494 6.82515 9.31857 6.64749 9.28912 6.46983C9.23021 6.04049 9.09768 5.62596 8.92098 5.22623C9.83396 4.91533 10.7911 4.75247 11.7777 4.75247C12.7643 4.75247 13.7215 4.91533 14.6345 5.22623C14.4431 5.62596 14.3253 6.04049 14.2664 6.46983C14.2369 6.64749 14.3105 6.82515 14.4578 6.92878L19.8915 10.9113C20.0241 11.0149 20.2155 11.0297 20.3775 10.9557C20.5395 10.8817 20.7162 10.7928 20.8487 10.6892C21.0843 10.5412 21.2905 10.3635 21.5408 10.1266C23.2048 8.45368 23.2048 5.71479 21.5408 4.04184C16.166 -1.36193 7.41897 -1.36193 2.04413 4.04184C0.380145 5.71479 0.380145 8.45368 2.04413 10.1266C2.27974 10.3635 2.50063 10.5412 2.70679 10.6596C2.86877 10.7632 3.03075 10.8669 3.19273 10.9409L3.178 10.9557ZM2.69206 4.72286C7.69875 -0.295979 15.842 -0.295979 20.8487 4.72286C22.1445 6.02569 22.1445 8.15759 20.8487 9.46041C20.672 9.63807 20.51 9.77131 20.3038 9.88975C20.2744 9.91936 20.2302 9.93417 20.2008 9.96378L15.2382 6.33659C15.3266 5.95167 15.4886 5.58154 15.6947 5.25584C15.7684 5.1374 15.7978 4.98935 15.7536 4.85611C15.7095 4.72286 15.6064 4.60442 15.4739 4.56001C14.2958 4.07145 13.0441 3.83457 11.7483 3.83457C10.4524 3.83457 9.20076 4.08625 8.02272 4.57481C7.89019 4.63403 7.78711 4.73767 7.74293 4.87091C7.69875 5.00416 7.72821 5.1522 7.80183 5.27064C8.02272 5.59635 8.1847 5.96647 8.25833 6.3514L3.29581 9.97858C3.29581 9.97858 3.20745 9.91936 3.16328 9.88975C3.0013 9.78612 2.83932 9.65288 2.64788 9.47522C1.35203 8.17239 1.35203 6.04049 2.64788 4.73767L2.69206 4.72286Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_7100_81">
        <rect width="22" height="11" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
